<template>
	<div
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		@click="onNodeClick(node)"
		:style="getWrapperStyle(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<!-- class="image-box__position--center" -->
		<div
			:style="getStyle(node)"
			:class="getClass(node)">
			<div class="image-box__wrapper">
				<figure class="image-box__img">
					<img :src="node.options.src" alt="">
				</figure>
				<div class="d-flex flex-column image-box__content">
					<h3 class="image-box__title">
						<!-- {{ node.options.title }} -->
						<NodeEditor
							:key="`title-${node.key}`"
							v-model="node.options.title"
							@focus="onNodeClick(node)"
						/>
					</h3>
					<p class="image-box__description">
						<!-- {{ node.options.description }} -->
						<NodeEditor
							:key="`desc-${node.key}`"
							v-model="node.options.description"
							@focus="onNodeClick(node)"
						/>
					</p>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
// eslint-disable-next-line
import NodeEditor from '@/components/funnels/pagebuilder/nodes/NodeEditor.vue';
import {
	removeHtmlTags,
	getNodeStyle,
// eslint-disable-next-line
} from '@/lib/helper';

export default {
	name: 'NodeImageBox',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
		NodeEditor,
	},
	computed: {
		tag() {
			return this.node?.options?.htmlTag ?? 'h2';
		},
	},
	watch: {},
	methods: {
		getClass(node) {
			let pClass = node.class || '';
			if (node.options && node.options.position) {
				pClass += ` image-box__position--${node.options.position}`;
			}

			return pClass;
		},
		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'text-color',
				'font-family',
				'font-weight',
				'font-size',
				'font-style',
				'text-decoration',
				'line-height',
				'padding',
				'border',
				'bg-color',
				'box-shadow',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		removeHtmlTags(str) {
			return removeHtmlTags(str);
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
		},
		onInput(value) {
			this.node.options.content = value;
		},
	},
};
</script>

<style lang="scss">
.image-box {
	&__position {

		&--left {
			.image-box {
				&__wrapper {
					display: flex;
					align-items: center;
				}

				&__content {
					margin-left: .7rem;
				}

				&__img {
					margin-bottom: 0;
				}
			}
		}

		&--center {
			text-align: center;

			.image-box {
				&__img {
					margin: 0 auto;
					padding-bottom: 1.5rem;
				}

				&__title {
					margin-bottom: 1rem;
				}
			}
		}

		&--right {
			.image-box {
				&__wrapper {
					display: flex;
					align-items: center;
					flex-direction: row-reverse;
					text-align: right;
				}

				&__content {
					margin-right: .7rem;
				}

				&__img {
					margin-bottom: 0;
				}
			}
		}
	}

	&__img {
		width: 30%;

		img {
			width: 100%;
		}
	}
}

.elementor-widget-image-box.elementor-vertical-align-top .elementor-image-box-wrapper {
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
}

</style>
